import { pages } from '@/settings/pages';
import { Scope } from '@/types/openid';

const REACT_APP_AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL as string;
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL as string;

export const ISSUER = REACT_APP_AUTH_BASE_URL;

export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
export const PUBLIC_CLIENT_ASSERTION_TYPE =
  'urn:ietf:params:oauth:client-assertion-type:none';
export const SCOPES: Scope[] = ['openid', 'organization'];

export const Url = {
  authorizationEndpointUri: `${REACT_APP_AUTH_BASE_URL}/auth/openid/authorize`,
  redirectUri: `${REACT_APP_BASE_URL}${pages.auth.openid.callBack}`,
  tokenUri: `${REACT_APP_AUTH_BASE_URL}/auth/openid/token`,
  jwksUri: `${REACT_APP_AUTH_BASE_URL}/auth/openid/keys`,
  revokeUri: `${REACT_APP_AUTH_BASE_URL}/auth/openid/revoke`,
  logoutUri: `${REACT_APP_AUTH_BASE_URL}/auth/openid/logout`,
  logoutRedirectUri: REACT_APP_BASE_URL,
  signinUri: `${REACT_APP_BASE_URL}/signin`,
} as const;
